namespace GeniuzPOS.PosShift {
    export namespace PsVatRefundPrintingParaService {
        export const baseUrl = 'PosShift/PsVatRefundPrintingPara';

        export declare function Create(request: Serenity.SaveRequest<PsVatRefundPrintingParaRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PsVatRefundPrintingParaRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PsVatRefundPrintingParaRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PsVatRefundPrintingParaRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "PosShift/PsVatRefundPrintingPara/Create",
            Update = "PosShift/PsVatRefundPrintingPara/Update",
            Delete = "PosShift/PsVatRefundPrintingPara/Delete",
            Retrieve = "PosShift/PsVatRefundPrintingPara/Retrieve",
            List = "PosShift/PsVatRefundPrintingPara/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PsVatRefundPrintingParaService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
